import { render, staticRenderFns } from "./HeaderIconsForProcessingBasket.vue?vue&type=template&id=3bfefeee&"
import script from "./HeaderIconsForProcessingBasket.vue?vue&type=script&lang=js&"
export * from "./HeaderIconsForProcessingBasket.vue?vue&type=script&lang=js&"
import style0 from "./HeaderIconsForProcessingBasket.vue?vue&type=style&index=0&id=3bfefeee&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports